const ON_PAGE_READY_HANDLERS = {};

/**
 * this method is used to register page onReady handler to be executed when page will be loaded
 * @param actions - array of actions where this handler should be executed. Action name should be in format
 * [<namespace if present>-]<controller_name>-<action_name>,
 * e.g. shipments-index or customers-show or admin-settings-show.
 * If callback should only be applied to single action, then you can pass single string instead of array
 * @param callback
 */
export function registerOnReadyHandler(actions, callback) {
  if (!(actions instanceof Array)) {
    actions = [actions];
  }
  actions.forEach(action => {
    if (ON_PAGE_READY_HANDLERS[action] != null) {
      ON_PAGE_READY_HANDLERS[action].push(callback);
    } else {
      ON_PAGE_READY_HANDLERS[action] = [callback];
    }
  });
}

/*
 * This method should only be called once in page onReady handler.
 * It will looks for registered with registerOnReadyHandler callbacks for current page and will run them
 * in order of registering
 */
export function executeOnReadyHandler() {
  const action = document.body.getAttribute("class");
  const callbacks = ON_PAGE_READY_HANDLERS[action];
  if (callbacks != null) {
    callbacks.forEach(callback => callback());
  }
}